import { Component, OnChanges, Input, Output, EventEmitter, Directive } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { Router } from '@angular/router';

import { SPListService } from '../services/seguiment-tecnic.service';
import { ISPI } from '../seguiment-tecnic.interfaces';

import * as moment from 'moment';

@Directive()
export class BaseSeguimentTecnicListComponent {
  @Input('elementList') elementList: any;
  @Output('requestRows') requestRows = new EventEmitter();

  public activeFilters: any = {stateReunio: true, stateMailstone: false};
  public currentOrdering: any = {};
  public orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  public showFilters: boolean = true;
  public orderingParameters: any;

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listService.currentPage * this.listService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listService.rowsPerPage - 1, this.elementList.registers);
  }
  
  public pendentRealitzar(data, dataR, op){
    var currentDate = moment().format("YYYY-MM-DD");
    if(op == 0)if(moment(currentDate).isAfter(data) && !dataR) return true;//Hauria d'estar realitzada
    if(op == 1)if(moment(currentDate).isAfter(data) && dataR) return true;//Realitzada
    if(op == 2)if(moment(currentDate).isBefore(data) && !dataR) return true;//Pendent
    return false;
  }
  
  private requestRowsToParent(): void {
    this.requestRows.emit({
      skip : (this.firstRegisterShown?this.firstRegisterShown:1) - 1,
      limit: this.listService.rowsPerPage,
      conds: { },
      filters: this.activeFilters,
      ordering: this.currentOrdering
    });
  }

  public computeActiveFilters($event) {
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listService.currentPage * this.listService.rowsPerPage;
    this.requestRowsToParent();
  }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  public requestPrevious(): void {
    this.listService.currentPage = Math.max(0, this.listService.currentPage - 1);
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public requestNext(): void {
    this.listService.currentPage = Math.min(Math.floor(this.elementList.registers / this.listService.rowsPerPage), this.listService.currentPage + 1);
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public gotoPage(page: number): void {
    this.listService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public navigateToProject(project) {
    this.router.navigate([this.routeKey, project.codi]);
  }

  public setRowPerPage(rowsPerPage: number) {
    this.listService.rowsPerPage = rowsPerPage;
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
    this.showFilters = !this.showFilters;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, public listService: SPListService, private router: Router, public tableFields, private routeKey: string,
              public validFilters: Array<any>,public ordreCamps: Array<any>) {
    this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    for(var i=0;i<ordreCamps.length;i++){this.orderingParameters[ordreCamps[i].key] = ordreCamps[i].sort;this.cycleOrdering(ordreCamps[i].key);}
  }

  public goProject(codi){ this.router.navigate(['project',codi]);};

  ngOnChanges(changes: any): void {
    const newElementList = changes.elementList.currentValue;
    if (newElementList)this.computeDisplayedRows();
  }
}

@Component({
  selector: 'mcrit-gestio-seguiment-tecnic-list',
  templateUrl: 'seguiment-tecnic-list.component.html',
  styleUrls: ['seguiment-tecnic-list.component.css'],
  providers: []
})
export class SeguimentTecnicListComponent extends BaseSeguimentTecnicListComponent {
  @Input('elementList') elementList: any;
  @Output('requestRows') requestRows = new EventEmitter();

  public title: string = 'Seguiment del treball';
  public seguimentTecnicData: Array<ISPI>;
  public isDate(field: string): boolean { return (field === 'data'); }

  ngOnInit() { this.computeActiveFilters({statePending: true}); }

  constructor(public translate: TranslateService, public languageService: LanguageService, listService: SPListService,router: Router) {
    super(translate, languageService, listService, router, [
      ['projecte_codi', 'Codi'],
      ['data', 'Data'],
      ['tipus', 'Tipus'],
      ['tecnic', 'Tècnic'],
    ], 'project', [
      {
        inputs: [
          {
            name: 'checkbox',
            type: 'checkbox',
            values: [
              {
                text: 'Coordinador',
                icon: 'coordinador',
                name: 'coordinador',
                value: false
              }]
          }
        ]
      },
      {
        inputs: [
          {
            name: 'text',
            type: 'text',
            values: [
              {
                text: 'Codi',//Text a mostrar label
                name: 'clau', //Camp de la base de dades (Si no manipulat al servidor)
                autocomplete: 'codiClau',//Crida per obtenir els valors si autocomplete
                value: listService.getSearchValues('projecte_codi')//valor a mostrar
              },
              {
                text: 'Data',
                name: 'data',
                value: '',//new Date().getFullYear().toString()+"/"+("0" + new Date().getMonth()+1).slice(-2).toString()+'/'+("0"+new Date().getDate()).slice(-2).toString()
              },
              {
                text: 'Tipus',
                name: 'tipus',
                autocomplete: 'tipusSeg',
                value: listService.getSearchValues('tipus')
              },
              {
                text: 'Tècnic',
                name: 'personal_id',
                autocomplete: 'tecnicMcrit',
                value: listService.getSearchValues('personal_id')
              }
            ]
          }
        ]
      }
    ],[{key:'data',sort: 2}]);
  };
}
